module.exports = __webpack_public_path__ + "img/about_us.6d667341.png";